// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options } from '@hey-api/client-fetch';
import type {
  FollowResourceData,
  FollowResourceError,
  FollowResourceResponse,
  UnfollowResourceData,
  UnfollowResourceError,
  UnfollowResourceResponse,
  UpdateFollowersData,
  UpdateFollowersError,
  UpdateFollowersResponse,
  GetResourceFollowersData,
  GetResourceFollowersError,
  GetResourceFollowersResponse,
  CheckFollowStatusBulkData,
  CheckFollowStatusBulkError,
  CheckFollowStatusBulkResponse,
} from './types.gen';

/**
 * Follow a Resource
 * Allows an authenticated user to follow a resource they have permission to view. The follower ID is derived from the authentication token.
 */
export const followResource = (options: Options<FollowResourceData>) => {
  return (options?.client ?? client).post<
    FollowResourceResponse,
    FollowResourceError
  >({
    ...options,
    url: '/context/{contextId}/follows',
  });
};

/**
 * Unfollow a Resource
 * Allows an authenticated user to unfollow a resource. The follower ID is derived from the authentication token. The follow record is permanently deleted.
 */
export const unfollowResource = (options: Options<UnfollowResourceData>) => {
  return (options?.client ?? client).delete<
    UnfollowResourceResponse,
    UnfollowResourceError
  >({
    ...options,
    url: '/context/{contextId}/follows',
  });
};

/**
 * Update Followers for a Resource
 * Atomically replaces the entire list of followers for a specific resource. This operation requires edit permissions on the resource. An empty list will remove all followers.
 */
export const updateFollowers = (options: Options<UpdateFollowersData>) => {
  return (options?.client ?? client).put<
    UpdateFollowersResponse,
    UpdateFollowersError
  >({
    ...options,
    url: '/context/{contextId}/followers',
  });
};

/**
 * Get Resource Followers
 * Retrieves a paginated list of all users and groups following a specific resource.
 */
export const getResourceFollowers = (
  options: Options<GetResourceFollowersData>
) => {
  return (options?.client ?? client).get<
    GetResourceFollowersResponse,
    GetResourceFollowersError
  >({
    ...options,
    url: '/context/{contextId}/followers',
  });
};

/**
 * Check Follow Status (Bulk)
 * Allows checking the following status for multiple follower-resource combinations in a single bulk request. The response provides a status for each item in the request.
 */
export const checkFollowStatusBulk = (
  options: Options<CheckFollowStatusBulkData>
) => {
  return (options?.client ?? client).post<
    CheckFollowStatusBulkResponse,
    CheckFollowStatusBulkError
  >({
    ...options,
    url: '/context/{contextId}/followers/status/_bulk',
  });
};
